import React, { useState, useEffect } from "react";
import Wrapper from "../../UI/Wrapper";
import image1 from "../../../Icons/accountIcon5.png";
import image2 from "../../../Icons/accountIcon6.png";
import image3 from "../../../Icons/accountIcon7.png";
import image4 from "../../../Icons/accountIcon8.png";
import image5 from "../../../Icons/accountIcon9.png";
import image6 from "../../../Icons/accountIcon10.png";
import image7 from "../../../Icons/accountIcon11.png";
import image8 from "../../../Icons/accountIcon12.png";
import image9 from "../../../Icons/accountIcon13.png";
import image10 from "../../../Icons/accountIcon14.png";
import image11 from "../../../Icons/accountIcon15.png";
import image12 from "../../../Icons/accountIcon16.png";
import dateIcon from "../../../Icons/dateIcon.png";
import icon_user from "../../../Icons/icon_user.png";
import axios from "axios";
import { DateRangePicker } from "react-date-range";
import SummaryCard from "../SummaryCard/SummaryCard";
import icon1 from "../../../Icons/accountIcon1.png";
import icon2 from "../../../Icons/accountIcon2.png";
import icon3 from "../../../Icons/accountIcon3.png";
import icon4 from "../../../Icons/accountIcon17.png";
import "../ShipmentData/ShipmentData.css";
import PiechartPayable from "../PiechartAccounts/PiechartPayable";
import PiechartReceivable from "../PiechartAccounts/PiechartReceivable";
import PiechartExpenses from "../PiechartAccounts/PiechartExpenses";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const LeadData = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [shipmentDataResponse, setshipmentDataResponse] = useState([]);
  const [initialLeadData, setInitialLeadData] = useState([]);
  const [dateRangePettyCash, setdateRangePettyCash] = useState("Custom Dates");
  const [isPettyCashPickerOpen, setPettyCashPickerOpen] = useState(false);
  const [pettyCash, setpettyCash] = useState([]);

  const [dateRangeExpenses, setdateRangeExpenses] = useState("Custom Dates");
  const [isExpensesPickerOpen, setExpensesPickerOpen] = useState(false);
  const [expensesResponse, setExpensesResponse] = useState([]);
  const [colorsExpense, setcolorsExpense] = useState({});

  const [cashFlowData, setcashFlowData] = useState([]);
  const [dateRangeCashFlow, setdateRangeCashFlow] = useState("Custom Dates");
  const [isCashFlowDataOpen, setisCashFlowDataOpen] = useState(false);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/getdashboardShipmentData?startDate=&enddate=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            if (response.data.data != null) {
              setshipmentDataResponse(response.data.data[0]);
              setInitialLeadData(response.data.data[0]);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(
          `${baseAPI}userget/getdashboardPettyCashData?startDate=&enddate=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            if (response.data.data != null) {
              setpettyCash(response.data.data[0]);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}userget/getdashboardExpensesData?startDate=&enddate=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            if (response.data.data != null) {
              setExpensesResponse(response.data.data);
              setcolorsExpense(generateColorsSource(response.data.data));
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}userget/getdashboardCashFlowData?startDate=&enddate=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            if (response.data.data != null) {
              setcashFlowData(response.data.data);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  function generateColorsSource(data) {
    const colorMapping = {};
    data.forEach((item) => {
      colorMapping[item.expense_type] =
        "#" + Math.floor(Math.random() * 16777215).toString(16);
    });
    return colorMapping;
  }

  function getLeadData() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);

    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = "";
      enddate = "";
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/getdashboardShipmentData?startDate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setshipmentDataResponse(response.data.data[0]);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  function clearFilter() {
    setDateRange("Custom Dates");
    setshipmentDataResponse(initialLeadData); // Reset to initial data
  }

  const [isOpen, setIsOpen] = useState(false);
  const [dateRange, setDateRange] = useState("Custom Dates");
  const togglePicker = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
        " - " +
        formatDate(selectionRange.endDate)
    );
    setIsOpen(!isOpen);
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const handleSelect = (ranges) => {
    // ranges contains an object with startDate and endDate
    setSelectionRange(ranges.selection);
  };

  const clearDateRange = () => {
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  const togglePettyCashPicker = () => {
    setPettyCashPickerOpen(!isPettyCashPickerOpen);
    // if (isLeadStagePickerOpen || isUserLeadDataOpen) {
    //   setLeadStagePickerOpen(false);
    //   setIsUserLeadDataOpen(false);
    // }
    if (isPettyCashPickerOpen || isCashFlowDataOpen || isExpensesPickerOpen) {
      setisCashFlowDataOpen(false);
      setExpensesPickerOpen(false);
    }
  };

  const toggleExpensePicker = () => {
    setExpensesPickerOpen(!isExpensesPickerOpen);
    if (isExpensesPickerOpen || isPettyCashPickerOpen || isCashFlowDataOpen) {
      setPettyCashPickerOpen(false);
      setisCashFlowDataOpen(false);
    }
  };

  const [selectionRangePettyCash, setselectionRangePettyCash] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const [selectionRangeExpenses, setselectionRangeExpenses] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleSelectPettyCash = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setselectionRangePettyCash({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  const handleSelectExpense = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setselectionRangeExpenses({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  const pettyCashApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = selectionRangePettyCash.startDate
      ? formatDate(selectionRangePettyCash.startDate)
      : "";
    let enddate = selectionRangePettyCash.endDate
      ? formatDate(selectionRangePettyCash.endDate)
      : "";

    if (startdate && enddate) {
      setdateRangePettyCash(startdate + " - " + enddate);
    } else {
      setdateRangePettyCash("Select Date Range");
    }

    setPettyCashPickerOpen(false);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/getdashboardPettyCashData?startDate=${startdate}&endDate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response && response.data && response.data.data) {
            setpettyCash(response.data.data[0]);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const expenseApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = selectionRangeExpenses.startDate
      ? formatDate(selectionRangeExpenses.startDate)
      : "";
    let enddate = selectionRangeExpenses.endDate
      ? formatDate(selectionRangeExpenses.endDate)
      : "";

    if (startdate && enddate) {
      setdateRangeExpenses(startdate + " - " + enddate);
    } else {
      setdateRangeExpenses("Select Date Range");
    }

    setExpensesPickerOpen(false);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/getdashboardExpensesData?startDate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response && response.data && response.data.data) {
            setExpensesResponse(response.data.data);
            setcolorsExpense(generateColorsSource(response.data.data));
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const closeButtonPettyCash = () => {
    setPettyCashPickerOpen(!isPettyCashPickerOpen);
  };

  const closeButtonExpenses = () => {
    setExpensesPickerOpen(!isExpensesPickerOpen);
  };

  const toggleCashFlowFilter = () => {
    setisCashFlowDataOpen(!isCashFlowDataOpen);
    if (isCashFlowDataOpen || isPettyCashPickerOpen || isExpensesPickerOpen) {
      setPettyCashPickerOpen(false);
      setExpensesPickerOpen(false);
    }
  };

  const [selectionRangeCashFlow, setselectionRangeCashFlow] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleSelectCashFlow = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setselectionRangeCashFlow({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  const cashFlowApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = selectionRangeCashFlow.startDate
      ? formatDate(selectionRangeCashFlow.startDate)
      : "";
    let enddate = selectionRangeCashFlow.endDate
      ? formatDate(selectionRangeCashFlow.endDate)
      : "";

    if (startdate && enddate) {
      setdateRangeCashFlow(startdate + " - " + enddate);
    } else {
      setdateRangeCashFlow("Select Date Range");
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/getdashboardCashFlowData?startDate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setcashFlowData(response.data.data);
            setisCashFlowDataOpen(!isCashFlowDataOpen);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const closeButtonRegionData = () => {
    setisCashFlowDataOpen(!isCashFlowDataOpen);
  };

  const data = [
    { name: "Payable", value: shipmentDataResponse.total_payable },
    { name: "Overdue", value: shipmentDataResponse.total_payable_overdue },
  ];

  const colors = {
    Payable: "#5B489D",
    Overdue: "#B5A4F0",
  };

  const dataReceivable = [
    { name: "Receivable", value: shipmentDataResponse.total_receivable },
    { name: "Overdue", value: shipmentDataResponse.total_receivable_overdue },
  ];

  const colorsReceivable = {
    Receivable: "#A3519F",
    Overdue: "#E7B4E5",
  };

  return (
    <>
      <Wrapper>
        <div className="justify-content-between align-items-center mb-4">
          {/* <h4>Shipment Data</h4> */}
          <div className="container-fluid" style={{ marginTop: "3rem" }}>
            <div style={{ display: "flex" }}>
              <div
                className=" headerButton"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "10px",
                  // justifyContent: "left",
                  height: "69px",
                  paddingBottom: "3px",
                }}
              >
                <div className="allFilterButtons">
                  <div className="filter-icon">
                    <img
                      src={require("../../../Icons/filterIcon.png")}
                      alt="filter"
                    />
                    FILTER
                  </div>

                  <div>
                    <button
                      style={{
                        marginBottom: "1rem",
                        width: "12rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        border: "1px solid black",
                      }}
                      onClick={togglePicker}
                    >
                      {" "}
                      <b> {dateRange}</b>
                    </button>
                    {isOpen && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 999,
                          border: "solid 1px black",
                          marginLeft: "-6pc",
                          width: "35pc",
                          background: "white",
                        }}
                      >
                        <DateRangePicker
                          ranges={[selectionRange]}
                          onChange={handleSelect}
                        />
                        <button
                          onClick={clearDateRange}
                          style={{
                            marginBottom: "1rem",
                            width: "5rem",
                            height: "2.5rem",
                            borderRadius: "0.5rem",
                            fontSize: "13px",
                            position: "relative",
                            top: "1px",
                            left: "22pc",
                            color: "red",
                            border: "none",
                          }}
                        >
                          Reset
                        </button>
                        <button
                          style={{
                            marginBottom: "1rem",
                            width: "7rem",
                            height: "2.5rem",
                            borderRadius: "0.5rem",
                            fontSize: "13px",
                            position: "relative",
                            top: "1px",
                            left: "22pc",
                            backgroundColor: "#5B489D",
                            color: "White",
                          }}
                          onClick={togglePicker}
                        >
                          Done
                        </button>
                      </div>
                    )}
                  </div>
                  <div>
                    <div
                      className="fafilterApply"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <div
                        className="Leadlist-filter"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <button onClick={getLeadData} className="">
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      className="fafilterresetApply"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <div
                        className="Leadlist-filter-clear"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <button onClick={clearFilter} className="">
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="right-div"
                  style={{
                    border: "1.5px solid #0C9800",
                    borderRadius: "7.5px",
                    padding: "5px",
                    width: "170px",
                    paddingLeft: "28px",
                    height: "36px",
                  }}
                >
                  <img
                    src={icon_user}
                    style={{
                      height: "15px",
                      width: "15px",
                      marginLeft: "-15px",
                    }}
                    alt="icon"
                  />
                  Active Users
                  <div
                    style={{
                      height: "34px",
                      width: "35px",
                      backgroundColor: "#0C9800",
                      position: "absolute",
                      borderRadius: "7.5px",
                      marginLeft: "6.6rem",
                      marginTop: "-1.8rem",
                    }}
                  >
                    <span>
                      <h5
                        style={{
                          padding: "5px",
                          paddingLeft: "13px",
                          color: "#FFFFFF",
                        }}
                      >
                        {shipmentDataResponse.active_users}
                      </h5>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div>
          <p style={{ fontSize: "24px", color: "#3D3D3D", fontWeight: "700" }}>
            Shipment Data
          </p>
        </div>
        <div className="directionThreeDivs">
          <div
            class="left-div"
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                border: "1px solid black",
                borderRadius: "7.5px",
                padding: "5px",
                width: "83px",
                paddingLeft: "13px",
                marginLeft: "4px",
              }}
            >
              <span class="purpledot"></span>
              Total
            </div>
            <div
              style={{
                border: "1px solid black",
                borderRadius: "7.5px",
                padding: "5px",
                width: "95px",
                paddingLeft: "14px",
                marginLeft: "10px",
              }}
            >
              <span class="lightbluedot"></span>
              Today's
            </div>
          </div>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="row mt-4">
        <div style={{ display: "flex" }}>
          <div className="col-3">
            <SummaryCard
              title="Total Sales (Execution)"
              value={`₹${shipmentDataResponse.total_sales}`}
              change={`${shipmentDataResponse.sales_lastMonth}%`}
              type={
                parseFloat(shipmentDataResponse.sales_lastMonth) >= 0
                  ? "up"
                  : "down"
              }
              background="#5B489D"
              icon={icon1}
            />
          </div>
          <div className="col-3">
            <SummaryCard
              title="Total COGS (Expense)"
              value={`₹${shipmentDataResponse.total_cogs}`}
              change={`${shipmentDataResponse.cogs_lastMonth}%`}
              type={
                parseFloat(shipmentDataResponse.cogs_lastMonth) >= 0
                  ? "up"
                  : "down"
              }
              background="#E2432E"
              icon={icon2}
            />
          </div>
          <div className="col-3">
            <SummaryCard
              title="Overall Gross Profit"
              value={`₹${shipmentDataResponse.gross_profit}`}
              change={`${shipmentDataResponse.profit_lastMonth}%`}
              type={
                parseFloat(shipmentDataResponse.profit_lastMonth) >= 0
                  ? "up"
                  : "down"
              }
              background="#49A84C"
              icon={icon3}
            />
          </div>
          <div className="col-3">
            <div style={{ border: "2px solid #FA9A0B", borderRadius: "10px" }}>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  backgroundColor: "#FA9A0B",
                  padding: "5px",
                  color: "white",
                  paddingLeft: "12px",
                }}
              >
                Total Quotation Amount
              </p>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    paddingLeft: "11px",
                  }}
                >
                  ₹ {shipmentDataResponse.total_quotation_amount}
                </p>
                <p
                  style={{
                    color:
                      parseFloat(
                        shipmentDataResponse.quotation_amount_lastMonth
                      ) >= 0
                        ? "green"
                        : "red",
                    padding: "5px 8px 0 0",
                  }}
                >
                  {shipmentDataResponse.quotation_amount_lastMonth} %
                  {parseFloat(
                    shipmentDataResponse.quotation_amount_lastMonth
                  ) >= 0
                    ? "↑"
                    : "↓"}
                </p>
              </div>
            </div>
            <div
              style={{
                border: "2px solid #A3519F",
                borderRadius: "10px",
                marginTop: "2%",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  backgroundColor: "#A3519F",
                  padding: "5px",
                  color: "white",
                  paddingLeft: "12px",
                  borderRadius: "8px 8px 0 0px",
                }}
              >
                Total Token Amount
              </p>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    paddingLeft: "11px",
                  }}
                >
                  ₹ {shipmentDataResponse.total_token_amount}
                </p>
                <p
                  style={{
                    color:
                      parseFloat(shipmentDataResponse.token_amount_lastMonth) >=
                      0
                        ? "green"
                        : "red",
                    padding: "5px 8px 0 0",
                  }}
                >
                  {shipmentDataResponse.token_amount_lastMonth} %
                  {parseFloat(shipmentDataResponse.token_amount_lastMonth) >= 0
                    ? "↑"
                    : "↓"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Job Stats */}
      <div className="row mt-4">
        {/* jobs */}
        <div
          className="col-9"
          style={{
            width: "72.7%",
            marginLeft: "1%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            className="row"
            style={{
              border: "2px solid #5B489D",
              marginBottom: "2%",
              backgroundColor: "white",
              borderRadius: "10px",
            }}
          >
            <div style={{ display: "flex", padding: "20px" }}>
              <div className="col">
                <img
                  src={image1}
                  alt="image1"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.total_job_received}</h3>
                <span>Total Job Received</span>
              </div>
              <div className="col">
                <img
                  src={image2}
                  alt="image2"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.total_job_open}</h3>
                <span>Total Job Open</span>
              </div>
              <div className="col">
                <img
                  src={image3}
                  alt="image3"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.total_un_job}</h3>
                <span>Total Untouched Job</span>
              </div>
              <div className="col">
                <img
                  src={image4}
                  alt="image4"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.total_job_done}</h3>
                <span>Total Job Done</span>
              </div>
              <div className="col">
                <img
                  src={image3}
                  alt="image3"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.total_cancel_job}</h3>
                <span>Total Cancelled Job</span>
              </div>
            </div>
          </div>
          <div
            className="row"
            style={{
              border: "2px solid #4D86F9",
              backgroundColor: "white",
              borderRadius: "10px",
            }}
          >
            <div style={{ display: "flex", padding: "20px" }}>
              <div className="col">
                <img
                  src={image5}
                  alt="image5"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.today_job_received}</h3>
                <span>Today's Job Received</span>
              </div>
              <div className="col">
                <img
                  src={image6}
                  alt="image6"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.today_job_open}</h3>
                <span>Today's Job Open</span>
              </div>
              <div className="col">
                <img
                  src={image7}
                  alt="image7"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.today_un_job}</h3>
                <span>Today's Untouched Job</span>
              </div>
              <div className="col">
                <img
                  src={image8}
                  alt="image8"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.today_job_done}</h3>
                <span>Today's Job Done</span>
              </div>
              <div className="col">
                <img
                  src={image7}
                  alt="image7"
                  style={{
                    width: "2rem",
                    height: "2rem",
                  }}
                />
                <h3>{shipmentDataResponse.today_cancel_job}</h3>
                <span>Today's Cancelled Job</span>
              </div>
            </div>
          </div>
        </div>
        {/* tasks */}
        <div className="col-3" style={{ width: "26%" }}>
          <Wrapper className="tasksWrapper">
            <table>
              <thead>
                <tr>
                  <th
                    style={{
                      backgroundColor: "#5B489D",
                      color: "#FFFFFF",
                      border: "none",
                    }}
                  >
                    Tasks
                  </th>
                  <th
                    style={{
                      backgroundColor: "#5B489D",
                      color: "#FFFFFF",
                      border: "none",
                      textAlign: "right",
                    }}
                  >
                    Pending Request
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      borderRadius: "10px 0px 0px 10px",
                      backgroundColor: "#F5F2FF",
                    }}
                  >
                    Payment Confirmation
                  </td>
                  <td
                    className="pendingRequestNumber"
                    style={{
                      backgroundColor: "#F5F2FF",
                      borderRadius: "0px 10px 10px 0px",
                    }}
                  >
                    {shipmentDataResponse.payment_confirmation}
                  </td>
                </tr>
                <tr>
                  <td>Refund & Cancellation</td>
                  <td className="pendingRequestNumber">
                    {shipmentDataResponse.refund_cancel}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderRadius: "10px 0px 0px 10px",
                      backgroundColor: "#F5F2FF",
                    }}
                  >
                    Add Inventory Request
                  </td>
                  <td
                    className="pendingRequestNumber"
                    style={{
                      backgroundColor: "#F5F2FF",
                      borderRadius: "0px 10px 10px 0px",
                    }}
                  >
                    {shipmentDataResponse.invent_request}
                  </td>
                </tr>
                <tr>
                  <td>Add Vendor Request</td>
                  <td className="pendingRequestNumber">
                    {shipmentDataResponse.vendor_request}
                  </td>
                </tr>
              </tbody>
            </table>
          </Wrapper>
        </div>
      </div>

      <div
        className="container-fluid py-2"
        style={{ backgroundColor: "revert" }}
      >
        <div className="row">
          {/* Left Section */}
          <div className="col-lg-6 col-md-12">
            {/* Follow-Up Cards */}
            <div className="row">
              {/* Today's Follow-up */}
              <div className="col-md-6 mb-3">
                <div
                  className="d-flex justify-content-between align-items-center pl-1 rounded"
                  style={{
                    backgroundColor: "#DD4477",
                    border: "2px solid #DD4477",
                  }}
                >
                  {/* <div style={{ backgroundColor: "#F3DBE3", padding: "20px 20px 20px 20px", borderRadius: "6px" }}>
              <img src={image9} alt="Today's Follow up" />
            </div>
            <div className="text-white text-end">
              <p>Today's Follow up</p>
              <p>{shipmentDataResponse.today_followup}</p>
            </div>
         */}
                  <div style={{ padding: "21px", backgroundColor: "#F3DBE3" }}>
                    <img src={image9} alt="Today's Follow up" />
                  </div>
                  <div style={{ color: "white", padding: "4px 10px 0px 0" }}>
                    <p style={{ fontSize: "12px" }}>Today's Follow up</p>
                    <p>{shipmentDataResponse.today_followup}</p>
                  </div>
                </div>
              </div>

              {/* Missed Follow-up */}
              <div className="col-md-6 mb-3">
                <div
                  className="d-flex justify-content-between align-items-center pl-1 rounded"
                  style={{
                    backgroundColor: "#FA9A0B",
                    border: "2px solid #FA9A0B",
                  }}
                >
                  <div style={{ backgroundColor: "#FBEBD1", padding: "21px" }}>
                    <img src={image10} alt="Missed Follow up" />
                  </div>
                  <div style={{ color: "white", padding: "4px 10px 0px 0" }}>
                    <p style={{ fontSize: "12px" }}>Missed Follow up</p>
                    <p>{shipmentDataResponse.missed_followup}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Update Cards */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <div
                  className="d-flex justify-content-between align-items-center pl-1 rounded"
                  style={{
                    backgroundColor: "#0C9800",
                    border: "2px solid #0C9800",
                  }}
                >
                  <div style={{ backgroundColor: "#D4E9CE", padding: "21px" }}>
                    <img src={image11} alt="Today's Update" />
                  </div>
                  <div style={{ color: "white", padding: "4px 10px 0px 0" }}>
                    <p style={{ fontSize: "12px" }}>Today's Update</p>
                    <p>{shipmentDataResponse.today_update}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div
                  className="d-flex justify-content-between align-items-center pl-1 rounded"
                  style={{
                    backgroundColor: "#0099C6",
                    border: "2px solid #0099C6",
                  }}
                >
                  <div style={{ backgroundColor: "#D2EAF3", padding: "21px" }}>
                    <img src={image12} alt="Execution Ratio" />
                  </div>
                  <div style={{ color: "white", padding: "4px 10px 0px 0" }}>
                    <p style={{ fontSize: "12px" }}>Execution Ratio</p>
                    <p>{shipmentDataResponse.execution_ratio}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Petty Cash Section */}
            <div className="mb-4">
              <Wrapper className="pettyCashWrapper">
                <div style={{ padding: "9px" }}>
                  <div
                    className="d-flex justify-content-between flex-wrap"
                    style={{ padding: "12px 15px 0px 16px" }}
                  >
                    <div>
                      <button
                        style={{
                          marginBottom: "1rem",
                          width: "8rem",
                          height: "2rem",
                          borderRadius: "0.5rem",
                          fontSize: "11px",
                          border: "1px solid #6A6A6A",
                        }}
                        onClick={togglePettyCashPicker}
                      >
                        <b>{dateRangePettyCash}</b>{" "}
                        <img
                          src={dateIcon}
                          alt="Date Icon"
                          style={{ height: "15px", paddingLeft: "20px" }}
                        />
                      </button>

                      {isPettyCashPickerOpen && (
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 999,
                            border: "solid 1px black",
                            marginLeft: "1pc",
                            width: "35pc",
                            background: "white",
                          }}
                        >
                          <DateRangePicker
                            ranges={[selectionRangePettyCash]}
                            onChange={handleSelectPettyCash}
                          />

                          <button
                            onClick={pettyCashApplyButton}
                            style={{
                              marginBottom: "1rem",
                              width: "8rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "17pc",
                              backgroundColor: "#5B489D",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Apply Filter
                          </button>

                          <button
                            onClick={closeButtonPettyCash}
                            style={{
                              marginBottom: "1rem",
                              width: "7.5rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "17pc",
                              color: "red",
                              backgroundColor: "white",
                              border: "none",
                              fontWeight: "bold",
                            }}
                          >
                            Close
                          </button>
                        </div>
                      )}
                    </div>
                    <button
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                        height: "30px",
                        width: "15%",
                        border: "none",
                      }}
                    >
                      Show All
                    </button>
                  </div>

                  <hr />

                  <div
                    className="d-flex flex-column flex-md-row justify-content-between px-3"
                    style={{ borderRadius: "18px" }}
                  >
                    <div className="mb-3" style={{ flex: 1 }}>
                      <p
                        style={{
                          fontSize: "21px",
                          fontWeight: "600",
                          color: "#6A6A6A",
                        }}
                      >
                        Petty Cash
                      </p>
                      <Wrapper className="pettyCashWrapper">
                        <p
                          style={{
                            backgroundColor: "#49A84C",
                            fontSize: "18px",
                            fontWeight: "500",
                            color: "white",
                            padding: "10px",
                            borderRadius: "11px 11px 0 0",
                          }}
                        >
                          Petty Cash Used
                        </p>
                        <span
                          style={{
                            fontSize: "24px",
                            fontWeight: "600",
                            color: "#6A6A6A",
                            paddingLeft: "9px",
                          }}
                        >
                          ₹ {pettyCash.petty_cash_used}
                        </span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingTop: "7px",
                          }}
                        >
                          <p style={{ paddingLeft: "6px" }}>vs last year</p>
                          <p
                            style={{
                              color:
                                parseFloat(pettyCash.last_year_cash_used) >= 0
                                  ? "green"
                                  : "red",
                              padding: "0px 8px 0 0",
                            }}
                          >
                            {pettyCash.last_year_cash_used} %
                            {parseFloat(pettyCash.last_year_cash_used) >= 0
                              ? "↑"
                              : "↓"}
                          </p>
                        </div>
                      </Wrapper>
                    </div>

                    <div style={{ flex: 1, padding: "14px" }}>
                      <table className="table ">
                        <tbody>
                          <tr>
                            <td>
                              <div
                                style={{
                                  backgroundColor: "#49A84C",
                                  height: "10px",
                                  width: "10px",
                                  borderRadius: "6px",
                                  display: "inline-block",
                                  marginRight: "6px",
                                }}
                              ></div>
                              Petty Cash Balance
                            </td>
                            <td>₹ {pettyCash.petty_cash_balance}</td>
                          </tr>
                          <tr>
                            <td>
                              <div
                                style={{
                                  backgroundColor: "#49A84C",
                                  height: "10px",
                                  width: "10px",
                                  borderRadius: "6px",
                                  display: "inline-block",
                                  marginRight: "6px",
                                }}
                              ></div>
                              Today's Petty Cash Request
                            </td>
                            <td>{pettyCash.today_request}</td>
                          </tr>
                          <tr>
                            <td>
                              <div
                                style={{
                                  backgroundColor: "#49A84C",
                                  height: "10px",
                                  width: "10px",
                                  borderRadius: "6px",
                                  display: "inline-block",
                                  marginRight: "6px",
                                }}
                              ></div>
                              Pending Petty Cash Request
                            </td>
                            <td>{pettyCash.pending_request}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Wrapper>
            </div>

            {/* expenses section */}
            <div className="mb-4">
              <Wrapper className="pettyCashWrapper">
                <div
                  className="d-flex flex-column flex-md-row justify-content-between px-3 shipment_Dateclass"
                  style={{ borderRadius: "18px" }}
                >
                  <div className="mb-3" style={{ flex: 1 }}>
                    <PiechartExpenses
                      data={expensesResponse}
                      colors={colorsExpense}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <div className="d-flex flex-column flex-md-row justify-content-between ">
                      <div style={{ paddingRight: "6px" }}>
                        <button
                          style={{
                            marginBottom: "1rem",
                            width: "8rem",
                            height: "1.8rem",
                            borderRadius: "0.5rem",
                            fontSize: "11px",
                            border: "1px solid #6A6A6A",
                          }}
                          onClick={toggleExpensePicker}
                        >
                          {" "}
                          <b> {dateRangeExpenses}</b>
                          <img
                            src={dateIcon}
                            alt="Date Icon"
                            style={{ height: "15px", paddingLeft: "20px" }}
                          />
                        </button>
                        {isExpensesPickerOpen && (
                          <div
                            style={{
                              position: "absolute",
                              zIndex: 999,
                              border: "solid 1px black",
                              marginLeft: "-13pc",
                              width: "35pc",
                              background: "white",
                            }}
                          >
                            <DateRangePicker
                              ranges={[selectionRangeExpenses]}
                              onChange={handleSelectExpense}
                            />

                            <button
                              onClick={expenseApplyButton}
                              style={{
                                marginBottom: "1rem",
                                width: "8rem",
                                height: "2.5rem",
                                borderRadius: "0.5rem",
                                fontSize: "13px",
                                position: "relative",
                                top: "1px",
                                left: "17pc",
                                backgroundColor: "#5B489D",
                                color: "White",
                                border: "none",
                              }}
                            >
                              Apply Filter
                            </button>
                            <button
                              onClick={closeButtonExpenses}
                              style={{
                                marginBottom: "1rem",
                                width: "7.5rem",
                                height: "2.5rem",
                                borderRadius: "0.5rem",
                                fontSize: "13px",
                                position: "relative",
                                top: "1px",
                                left: "17pc",
                                color: "red",
                                backgroundColor: "white",
                                border: "none",
                                fontWeight: "bold",
                              }}
                            >
                              Close
                            </button>
                          </div>
                        )}
                      </div>
                      <div>
                        <button
                          style={{
                            backgroundColor: "#5B489D",
                            border: "none",
                            color: "white",
                            height: "28px",
                            width: "89px",
                          }}
                        >
                          Show All
                        </button>
                      </div>
                    </div>
                    <hr />
                    <p
                      style={{
                        fontSize: "19px",
                        fontWeight: "700",
                        color: "#6A6A6A",
                      }}
                    >
                      Expenses
                    </p>
                    <div style={{ height: "8rem", overflowX: "auto" }}>
                      <table className="table ">
                        <thead style={{ position: "sticky", top: "0" }}>
                          <th style={{ border: "none" }}>Expense Type</th>
                          <th style={{ border: "none" }}>Amount</th>
                        </thead>
                        <tbody>
                          {expensesResponse.map((item, index) => (
                            <tr
                              style={{ borderBottom: "1px solid #ccc" }}
                              key={index}
                            >
                              <td>
                                <ul>
                                  <span
                                    style={{
                                      color: colorsExpense[item.expense_type],
                                      fontWeight: "bold",
                                    }}
                                  >
                                    &#9679;
                                  </span>{" "}
                                  {item.expense_type}
                                </ul>
                              </td>
                              <td>{item.amount}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Wrapper>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-lg-6 col-md-12">
            <div className="row">
              {/* Payable */}
              <div className="col-md-6 mb-3">
                <Wrapper className="payableWrapper">
                  <div className="d-flex justify-content-between">
                    <p className="fw-bold" style={{ color: "#5B489D" }}>
                      Payable
                    </p>
                    <img
                      src={icon4}
                      alt="Payable Icon"
                      style={{ height: "14px" }}
                    />
                  </div>
                  <p className="h5 fw-bold">
                    ₹ {shipmentDataResponse.total_payable}
                  </p>
                  <p
                    className="text-muted small fw-semibold"
                    style={{
                      color: "#8B8B8B",
                      fontStyle: "italic",
                      fontWeight: "600",
                    }}
                  >
                    Total Outstanding Payable
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "13px",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          height: "7px",
                          width: "8px",
                          borderRadius: "9px",
                          marginTop: "7px",
                          backgroundColor: "#5B489D",
                        }}
                      ></div>
                      Payable
                    </div>
                    <div style={{ display: "flex", paddingLeft: "10px" }}>
                      <div
                        style={{
                          height: "7px",
                          width: "8px",
                          borderRadius: "9px",
                          marginTop: "7px",
                          backgroundColor: "#B5A4F0",
                        }}
                      ></div>
                      Overdue
                    </div>
                  </div>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#6A6A6A",
                      fontWeight: "600",
                      paddingTop: "3px",
                    }}
                  >
                    Overdue Payable
                  </p>
                  <PiechartPayable data={data} colors={colors} />
                </Wrapper>
              </div>

              {/* Receivable */}
              <div className="col-md-6">
                <Wrapper className="payableWrapper">
                  <div className="d-flex justify-content-between">
                    <p className="fw-bold" style={{ color: "#A3519F" }}>
                      Receivable
                    </p>
                    <img
                      src={icon4}
                      alt="Receivable Icon"
                      style={{ height: "14px" }}
                    />
                  </div>
                  <p className="h5 fw-bold">
                    ₹ {shipmentDataResponse.total_receivable}
                  </p>
                  <p
                    className="text-muted small fw-semibold"
                    style={{
                      color: "#8B8B8B",
                      fontStyle: "italic",
                      fontWeight: "600",
                    }}
                  >
                    Total Outstanding Receivable
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "13px",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          height: "7px",
                          width: "8px",
                          borderRadius: "9px",
                          marginTop: "7px",
                          backgroundColor: "#A3519F",
                        }}
                      ></div>
                      Receivable
                    </div>
                    <div style={{ display: "flex", paddingLeft: "10px" }}>
                      <div
                        style={{
                          height: "7px",
                          width: "8px",
                          borderRadius: "9px",
                          marginTop: "7px",
                          backgroundColor: "#E7B4E5",
                        }}
                      ></div>
                      Overdue
                    </div>
                  </div>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#6A6A6A",
                      fontWeight: "600",
                      paddingTop: "3px",
                    }}
                  >
                    Overdue Receivable
                  </p>
                  <PiechartReceivable
                    data={dataReceivable}
                    colors={colorsReceivable}
                  />
                </Wrapper>
              </div>
            </div>

            {/* cash flow  */}
            <div className="mb-4">
              <Wrapper className="pettyCashWrapper">
                <div style={{ padding: "17px" }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{}}>
                      <button
                        style={{
                          marginBottom: "1rem",
                          width: "8rem",
                          height: "1.8rem",
                          borderRadius: "0.5rem",
                          fontSize: "11px",
                          border: "1px solid #6A6A6A",
                        }}
                        onClick={toggleCashFlowFilter}
                      >
                        {" "}
                        <b> {dateRangeCashFlow}</b>
                        <img
                          src={dateIcon}
                          alt="Date Icon"
                          style={{ height: "15px", paddingLeft: "20px" }}
                        />
                      </button>
                      {isCashFlowDataOpen && (
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 999,
                            border: "solid 1px black",
                            marginLeft: "-9pc",
                            width: "35pc",
                            background: "white",
                          }}
                        >
                          <DateRangePicker
                            ranges={[selectionRangeCashFlow]}
                            onChange={handleSelectCashFlow}
                          />
                          <button
                            onClick={cashFlowApplyButton}
                            style={{
                              marginBottom: "1rem",
                              width: "8rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "17pc",
                              backgroundColor: "#5B489D",
                              color: "White",
                              border: "none",
                            }}
                          >
                            Apply Filter
                          </button>
                          <button
                            style={{
                              marginBottom: "1rem",
                              width: "7.5rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "17pc",
                              color: "red",
                              backgroundColor: "white",
                              border: "none",
                              fontWeight: "bold",
                            }}
                            onClick={closeButtonRegionData}
                          >
                            Close
                          </button>
                        </div>
                      )}
                    </div>
                    <div>
                      <button
                        style={{
                          width: "6rem",
                          backgroundColor: "#5B489D",
                          border: "none",
                          color: "white",
                          height: "28px",
                        }}
                      >
                        Show All
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <p
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#6A6A6A",
                        }}
                      >
                        Cash Flow
                      </p>
                    </div>
                    <div style={{ display: "flex", fontSize: "13px" }}>
                      <div style={{ padding: "2px", display: "flex" }}>
                        <div
                          style={{
                            width: "0.4rem",
                            height: "0.4rem",
                            borderRadius: "3px",
                            marginTop: "7px",
                            backgroundColor: "#EDEDED",
                          }}
                        ></div>
                        <p style={{ paddingLeft: "3px" }}>Overall</p>
                      </div>
                      <div
                        style={{ padding: "2px 0px 0px 21px", display: "flex" }}
                      >
                        <div
                          style={{
                            width: "0.4rem",
                            height: "0.4rem",
                            borderRadius: "3px",
                            marginTop: "7px",
                            backgroundColor: "#4A7869",
                          }}
                        ></div>
                        <p style={{ paddingLeft: "3px" }}>In Flow</p>
                      </div>
                      <div
                        style={{ padding: "2px 0px 0px 21px", display: "flex" }}
                      >
                        <div
                          style={{
                            width: "0.4rem",
                            height: "0.4rem",
                            borderRadius: "3px",
                            marginTop: "7px",
                            backgroundColor: "#B8DE55",
                          }}
                        ></div>
                        <p style={{ paddingLeft: "3px" }}> Out Flow</p>
                      </div>
                    </div>
                  </div>

                  <ResponsiveContainer width="100%" height={280}>
                    <BarChart
                      width={600}
                      height={400}
                      data={cashFlowData}
                      margin={{
                        top: 30,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                      barCategoryGap="20%"
                      barGap="5%"
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="MonthName" />

                      <Tooltip />
                      {/* <Legend
                        wrapperStyle={{ color: "black" }}
                        className="custom-legend"
                      /> */}
                      <Bar
                        style={{ color: "black" }}
                        dataKey="out_flow_cash"
                        fill="#B8DE55"
                        stackId="a"
                        barSize={30}
                      />
                      <Bar
                        dataKey="in_flow_cash"
                        fill="#4A7869"
                        stackId="a"
                        barSize={30}
                      />
                      <Bar
                        dataKey="overall_cash_flow"
                        fill="#EDEDED"
                        stackId="a"
                        barSize={30}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadData;
